import gql from 'graphql-tag';

export default fields => gql`
query ($filter: TableDataStreamFilterInput, $limit: Int, $nextToken: String) {
  listDataStreams (filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      __typename
      ${[...['id', 'name'].concat(fields)]}     
    }
    nextToken
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/DataStreams/AllQuery.js